import React, { useEffect, useRef } from "react"

import classNames from "classnames"

import { LinkTag } from "scrivito"
import { generateUUID } from "shared/lib/generateUUID"
import { getDocument } from "shared/lib/getDocument"
import { useValueRef } from "shared/lib/useValueRef"

const ScrivitoLinkComponent = React.forwardRef(
  (
    props: React.ComponentProps<typeof LinkTag> & {
      label?: string
      className?: string
    },
    ref: React.ForwardedRef<HTMLAnchorElement>
  ) => {
    const internalID = useRef(generateUUID())
    const idRef = useValueRef<string>(
      (props.id as string) || internalID.current
    )
    const wrapperRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
      const element = getDocument()?.getElementById(idRef.current)
      if (element) {
        if (typeof ref === "function") {
          ref(element as HTMLAnchorElement)
        } else if (ref) {
          // eslint-disable-next-line no-param-reassign
          ref.current = wrapperRef.current?.firstChild as HTMLAnchorElement
        }
      }
    }, [ref])

    return props.to ? (
      <LinkTag
        {...props}
        id={idRef.current}
        className={classNames(props.className)}
        aria-label={props.label}
      >
        {props.children}
      </LinkTag>
    ) : null
  }
)
export const ScrivitoLink = React.memo(
  ScrivitoLinkComponent
) as typeof ScrivitoLinkComponent
